import { readSharedFileFromRepo } from '../code-file-store'

async function readSharedUserFile(fileId) {
  const { content } = readSharedFileFromRepo(fileId)
  return content
}

export { readSharedUserFile }